import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';

import { MapContext } from '../../context/map';
import useTranslation from '../../hooks/use_translation';

const MapMarker = ({
	address,
	center,
	city,
	excerpt,
	groups,
	image_header,
	location_id,
	location_settings,
	position,
	slug,
	subtitle,
	title,
	url,
	zip_code,
}) => {
	const { addLocation, locations, map } = useContext(MapContext);
	const [infowindow, setInfowindow] = useState();
	const { t } = useTranslation('component_location_map_marker');
	const marker = locations[location_id]?.marker;

	useEffect(() => {
		if (!marker) {
			addLocation(
				{
					address,
					city,
					excerpt,
					groups,
					image_header,
					location_id,
					location_settings,
					position,
					slug,
					subtitle,
					title,
					url,
					zip_code,
				},
				new window.google.maps.Marker(),
			);

			setInfowindow(
				new window.google.maps.InfoWindow({
					ariaLabel: 'Uluru',
					content: `<div><p>${title}</p><p>${excerpt}</p><a href="${url}">${t(
						't1',
					)}</a></div>`,
				}),
			);
		}

		return () => {
			if (marker) {
				marker.setMap(null);
			}
		};
	}, [
		addLocation,
		address,
		city,
		excerpt,
		groups,
		image_header,
		location_id,
		location_settings,
		marker,
		position,
		slug,
		subtitle,
		t,
		title,
		url,
		zip_code,
	]);

	useEffect(() => {
		if (marker) {
			['click'].forEach((eventName) =>
				window.google.maps.event.clearListeners(marker, eventName),
			);

			marker.addListener('click', () => {
				infowindow.open({
					anchor: marker,
					map,
				});
			});
		}
	}, [infowindow, map, marker]);

	useEffect(() => {
		if (marker) {
			marker.setOptions({
				map,
				position: { lat: position.latitude, lng: position.longitude },
			});

			if (center) {
				map.panTo(marker.getPosition());
				map.setZoom(14);
			}
		}
	}, [center, map, marker, position]);
	return null;
};

MapMarker.propTypes = {
	address: PropTypes.string,
	center: PropTypes.bool,
	city: PropTypes.string,
	excerpt: PropTypes.string,
	groups: PropTypes.array,
	image_header: PropTypes.object,
	location_id: PropTypes.number,
	location_settings: PropTypes.object,
	map: PropTypes.object,
	position: PropTypes.object,
	slug: PropTypes.string,
	subtitle: PropTypes.string,
	title: PropTypes.string,
	url: PropTypes.string,
	zip_code: PropTypes.string,
};

export default MapMarker;
